import axios from "axios";

import { store } from './';
import { signinSilent } from '../Authorization';

/*
 * Flags - LOCAL_DEV must be disabled for production
 *
 */
export const LOCAL_DEV = false

export const EMULATION_ALL = false
const EMULATION_TOKEN = false


/*
 * URL setup
 *
 */

let tokenPath = 'https://salesforce-t03-4608.reico.com'

export let apiUrlBase = 'http://localhost:5001'
export let apiUrl = apiUrlBase + '/bridgesys/'

export function setBaseUrl(urlBase) {
    if (urlBase[urlBase.length - 1] === '/') {
        urlBase = urlBase.slice(0, -1);
    }

    if (!LOCAL_DEV) {
        apiUrlBase = urlBase;
        tokenPath = '';
    }
}

export function buildRequestUrl(partialUrl) {
    if (typeof partialUrl === 'undefined') {
        return apiUrlBase;
    }

    if (partialUrl[0] === '/') {
        partialUrl = partialUrl.slice(1, partialUrl.length);
    }

    return apiUrlBase + '/bridgesys/' + partialUrl.replace('bridgesys/', '');
}

/*
 * Authentication
 *
 */
export const devToken = ""

export function execWithApiToken(dispatch, action, resolve) {
    const state = store.getState();
    var user = state.oidc.user;

    if (LOCAL_DEV) {
        user = {
            expired: false,
            access_token: ""
        }
    }

    if (user !== null && !user.expired) {
        resolve(dispatch, user.access_token);
    } else {
        signinSilent(dispatch, resolve);
    }
}

/*
 * Emulation data
 *
 */

export let EmulatedProductData =
    [
        {
            id: 1,
            manufacturer: 'VIA',
            description: 'product 1',
            template: ['ta', 'tb', 'tc'],
            template_formula: null,
            epi_blocked: true,
            missing_images: false,
            override: false,
            product_line: 'BA',
            part_number: 'RO25X19',
            vendor_sku: 'v1',
            reico_sku: 'vir.cm.brw.st.a.025.19.02.dp1.ro.1.c.nnn.cmbwh.04',
            product_name: 'Cultured Marble 25X19 Bright White Recessed Oval Single Bowl Dripless Edge 4" faucet drills',
            product_code: '780',
            url: 'www.proda.com',
            upc: '45678901'
        },
        {
            id: 2,
            manufacturer: 'VIA',
            description: 'product 2',
            template: ['tb'],
            template_formula: 'tb',
            epi_blocked: false,
            missing_images: true,
            override: false,
            product_line: 'BA',
            part_number: 'RO25X22',
            vendor_sku: 'v2',
            reico_sku: 'vir.cm.brw.st.a.025.22.02.dp1.ro.1.c.nnn.cmbwh.04',
            product_name: 'Cultured Marble 25X22 Bright White Recessed Oval Single Bowl Dripless Edge 4" faucet drills',
            product_code: '781',
            url: 'www.prodb.com',
            upc: '34561084'
        },
        {
            id: 3,
            manufacturer: 'VIB',
            description: 'product 3',
            template: ['tc', 'td'],
            template_formula: 'tc',
            epi_blocked: true,
            missing_images: false,
            override: true,
            product_line: 'BB',
            part_number: 'RO28X22',
            vendor_sku: 'v3',
            reico_sku: 'vir.cm.brw.st.a.028.22.02.dp1.ro.1.c.nnn.cmbwh.04',
            product_name: 'Cultured Marble 28X22 Bright White Recessed Oval Single Bowl Dripless Edge 4" faucet drills',
            product_code: '781',
            url: 'www.prodc.com',
            upc: '78901084'
        },
        {
            id: 4,
            manufacturer: 'VIB',
            description: 'product 4',
            template: ['td'],
            template_formula: null,
            epi_blocked: false,
            missing_images: true,
            override: true,
            product_line: 'BB',
            part_number: 'RO31X19',
            vendor_sku: 'v4',
            reico_sku: 'vir.cm.brw.st.a.031.19.02.dp1.ro.1.c.nnn.cmbwh.04',
            product_name: 'Cultured Marble 31X19 Bright White Recessed Oval Single Bowl Dripless Edge 4" faucet drills',
            product_code: '780',
            url: 'www.proda.com',
            upc: '34561204'
        },
        {
            id: 5,
            manufacturer: 'VIC',
            description: 'product 5',
            template: ['te'],
            template_formula: null,
            epi_blocked: true,
            missing_images: false,
            override: false,
            product_line: 'BC',
            part_number: 'RO31X22',
            vendor_sku: 'v5',
            reico_sku: 'vir.cm.brw.st.a.031.22.02.dp1.ro.1.c.nnn.cmbwh.04',
            product_name: 'Cultured Marble 31X22 Bright White Recessed Oval Single Bowl Dripless Edge 4" faucet drills',
            product_code: '781',
            url: 'www.prodb.com',
            upc: '78901204'
        },
        {
            id: 6,
            manufacturer: 'VIC',
            description: 'product 6',
            template: ['tf', 'tg'],
            template_formula: 'tf',
            epi_blocked: false,
            missing_images: true,
            override: true,
            product_line: 'BC',
            part_number: 'RO34X22',
            vendor_sku: 'v6',
            reico_sku: 'vir.cm.brw.st.a.034.22.02.dp1.ro.1.c.nnn.cmbwh.04',
            product_name: 'Cultured Marble 34X22 Bright White Recessed Oval Single Bowl Dripless Edge 4" faucet drills',
            product_code: '780',
            url: 'www.prodc.com',
            upc: '34561444'
        },
        {
            id: 7,
            manufacturer: 'VID',
            description: 'product 7',
            template: ['tg', 'th'],
            template_formula: null,
            epi_blocked: true,
            missing_images: false,
            override: true,
            product_line: 'BD',
            part_number: 'RO37X19',
            vendor_sku: 'v7',
            reico_sku: 'vir.cm.brw.st.a.037.19.02.dp1.ro.1.c.nnn.cmbwh.04',
            product_name: 'Cultured Marble 37X19 Bright White Recessed Oval Single Bowl Dripless Edge 4" faucet drills',
            product_code: '781',
            url: 'www.proda.com',
            upc: '78901444'
        },
        {
            id: 8,
            manufacturer: 'VID',
            description: 'product 8',
            template: ['th'],
            template_formula: 'th',
            epi_blocked: false,
            missing_images: true,
            override: false,
            product_line: 'BD',
            part_number: 'RO37X22',
            vendor_sku: 'v8',
            reico_sku: 'vir.cm.brw.st.a.037.22.02.dp1.ro.1.c.nnn.cmbwh.04',
            product_name: 'Cultured Marble 37X22 Bright White Recessed Oval Single Bowl Dripless Edge 4" faucet drills',
            product_code: '781',
            url: 'www.prodb.com',
            upc: '34560184'
        },
        {
            id: 9,
            manufacturer: 'VIE',
            description: 'product 9',
            template: ['ti'],
            template_formula: 'ti',
            epi_blocked: true,
            missing_images: false,
            override: true,
            product_line: 'BE',
            part_number: 'RO43X22',
            vendor_sku: 'v9',
            reico_sku: 'vir.cm.brw.st.a.043.22.02.dp1.ro.1.c.nnn.cmbwh.04',
            product_name: 'Cultured Marble 43X22 Bright White Recessed Oval Single Bowl Dripless Edge 4" faucet drills',
            product_code: '781',
            url: 'www.prodc.com',
            upc: '78901184'
        }
    ]


/*
 * No Data error 
 * 
 */

export function clearNoDataError(dispatch) {

    dispatch(
        {
            type: 'NODATA_ERROR_CLEAR'
        }
    )
}

export * from '../Authorization/actions';



